import { SxProps, Theme } from '@mui/material'

export const searchStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  } as SxProps<Theme>,

  searchInputWrapper: {
    flexShrink: 0,
    pt: 2,
  } as SxProps<Theme>,

  searchInputRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    mb: 1.5,
  } as SxProps<Theme>,

  closeButton: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: '8px',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    transition: 'background-color 0.15s ease, color 0.15s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  }),

  closeIcon: {
    fontSize: 20,
  } as SxProps<Theme>,

  searchIcon: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.text.secondary,
    fontSize: 20,
  }),

  textField: (theme: Theme): SxProps<Theme> => ({
    '& .MuiOutlinedInput-root': {
      borderRadius: 1.5,
      backgroundColor: theme.palette.background.paper,
      fontSize: '0.875rem',
    },
  }),

  scrollableResults: {
    flex: 1,
    overflowY: 'auto',
    pb: 4,
  } as SxProps<Theme>,

  sectionWrapper: {
    mb: 1.5,
  } as SxProps<Theme>,

  sectionHeader: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    letterSpacing: 0.8,
    px: 1,
    mb: 0.25,
  }),

  sectionIcon: (theme: Theme): SxProps<Theme> => ({
    fontSize: 14,
    color: theme.palette.text.disabled,
    mr: 0.75,
    flexShrink: 0,
  }),

  recentIcon: (theme: Theme): SxProps<Theme> => ({
    fontSize: 14,
    mr: 0.75,
    color: theme.palette.text.disabled,
  }),

  inheritTypography: {
    fontSize: 'inherit',
    fontWeight: 'inherit',
    letterSpacing: 'inherit',
  } as SxProps<Theme>,

  row: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    pl: '28px',
    pr: 1,
    py: '3px',
    borderRadius: '4px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }),

  rowItemName: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  } as SxProps<Theme>,

  rowSectionLabel: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.text.disabled,
    fontSize: '0.7rem',
    ml: 1,
    flexShrink: 0,
  }),

  recentTimestamp: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.text.disabled,
    fontSize: '0.7rem',
    ml: 1.5,
    flexShrink: 0,
    minWidth: 60,
    textAlign: 'right',
  }),

  sectionCount: (theme: Theme): SxProps<Theme> => ({
    fontSize: 'inherit',
    fontWeight: 400,
    letterSpacing: 'inherit',
    ml: 0.5,
    color: theme.palette.text.disabled,
  }),

  moreButton: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    pl: '28px',
    pr: 1,
    py: '3px',
    borderRadius: '4px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }),

  moreButtonText: (theme: Theme): SxProps<Theme> => ({
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.text.disabled,
  }),

  expandMoreIcon: (theme: Theme): SxProps<Theme> => ({
    fontSize: 14,
    color: theme.palette.text.disabled,
    ml: 0.25,
  }),

  articleChip: {
    ml: 1,
    height: 18,
    fontSize: '0.625rem',
    flexShrink: 0,
    '& .MuiChip-label': { px: 0.75 },
  } as SxProps<Theme>,

  noResults: {
    textAlign: 'center',
    py: 4,
  } as SxProps<Theme>,

  noResultsText: {
    fontSize: '0.8125rem',
  } as SxProps<Theme>,
}
